import React from 'react';

const TrackerPageConfig: any = {
	settings: {
		layout: {
			config: {
				adminPage: true,
			},
		},
	},
	routes: [
		{
			path: '/admin/home/tracker',
			exact: true,
			component: React.lazy(() => import('./TrackerPage')),
		},
	],
};

export default TrackerPageConfig;
